import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SecurityScreeningSummary } from '@models/security-screening-summary.model';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DataService } from './data.service';

@Injectable()
export class LEConnectionsDataService extends DataService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Gets the list of security screening records
   */
  getCurrentSecurityScreeningItems(): Observable<SecurityScreeningSummary> {
    const apiPath = 'api/le-connections/current-security-summary';
    return this.http
      .get<SecurityScreeningSummary>(apiPath, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }
}
